import { defineStore } from 'pinia';

export const useLoaderStore = defineStore('loader', {
  state: () => ({
    tasks: 0
  }),
  actions: {
    startProgress() {
      this.tasks++;
    },
    stopProgress() {
      this.tasks = Math.max(0, this.tasks - 1);
    }
  }
});
